import { AxiosResponse } from "axios";
import baseUrl from "services/api";
import type {
  FindMapParms,
  ResponseAllCitysFilterTypes,
  ResponseFindClientsByCity,
  ResponseFindMapTypes,
} from "types/mapTypes";

export async function FindClientsMapFunction(
  parms: FindMapParms
): Promise<ResponseFindMapTypes[]> {
  const response: AxiosResponse<ResponseFindMapTypes[]> = await baseUrl.get(
    `clientes/empresasMapa`,
    {
      params: {
        ...parms,
        dias: 30,
      },
    }
  );
  return response.data;
}

export async function FindAllCitysFilterFunction(): Promise<
  ResponseAllCitysFilterTypes[]
> {
  const response: AxiosResponse<ResponseAllCitysFilterTypes[]> =
    await baseUrl.get(`clientes/cidades`);
  return response.data;
}

export async function FindCitysByClientsFunction(): Promise<
  ResponseFindClientsByCity
> {
  const response: AxiosResponse<ResponseFindClientsByCity> =
    await baseUrl.get(`clientes/cidadesEmpresas`);
  return response.data;
}